import { cn } from "@/utils/cn";
import { memo } from "react";

interface FavouritesIconProps {
  className?: string;
  filled?: boolean;
}

export const FavouritesIcon = memo(function FavouritesIcon({
  className,
  filled = false,
}: FavouritesIconProps) {
  if (filled) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        className={cn("fill-your-foods", className)}
      >
        <path d="M5 2.5H12C12.1388 2.5 12.268 2.55317 12.3604 2.6416C12.452 2.72958 12.5 2.84471 12.5 2.95996V13.499L12.499 13.5C12.4954 13.4998 12.493 13.4985 12.4922 13.498H12.4932L8.75684 11.2568L8.5 11.1025L8.24316 11.2568L4.50781 13.498C4.50706 13.4985 4.50463 13.4998 4.50098 13.5L4.5 13.499V2.95996C4.50002 2.84471 4.54801 2.72958 4.63965 2.6416C4.73197 2.55317 4.86115 2.5 5 2.5Z" />
      </svg>
    );
  }
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("fill-black", className)}
    >
      <path d="M17 3H6.5C6.10218 3 5.72064 3.15804 5.43934 3.43934C5.15804 3.72064 5 4.10218 5 4.5V21C5.00007 21.1338 5.03595 21.2652 5.10393 21.3805C5.17191 21.4958 5.2695 21.5908 5.38659 21.6557C5.50367 21.7206 5.63598 21.7529 5.76978 21.7494C5.90358 21.7458 6.034 21.7066 6.1475 21.6356L11.75 18.1341L17.3534 21.6356C17.4669 21.7063 17.5972 21.7454 17.7309 21.7488C17.8646 21.7522 17.9967 21.7198 18.1136 21.655C18.2306 21.5902 18.3281 21.4953 18.396 21.3801C18.4639 21.2649 18.4998 21.1337 18.5 21V4.5C18.5 4.10218 18.342 3.72064 18.0607 3.43934C17.7794 3.15804 17.3978 3 17 3ZM17 19.6472L12.1466 16.6144C12.0274 16.5399 11.8896 16.5004 11.7491 16.5004C11.6085 16.5004 11.4708 16.5399 11.3516 16.6144L6.5 19.6472V4.5H17V19.6472Z" />
    </svg>
  );
});
